import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VApp from 'vuetify/es5/components/VApp'
import Vuetify from 'vuetify/es5/components/Vuetify'
import VNavigationDrawer from 'vuetify/es5/components/VNavigationDrawer'
import VMenu from 'vuetify/es5/components/VMenu'
import VList from 'vuetify/es5/components/VList'
import VSubheader from 'vuetify/es5/components/VSubheader'
import VDivider from 'vuetify/es5/components/VDivider'
import VToolbar from 'vuetify/es5/components/VToolbar'
import VContent from 'vuetify/es5/components/VGrid'
import VTooltip from 'vuetify/es5/components/VTooltip'
import VBtn from 'vuetify/es5/components/VBtn'
import VBtnToggle from 'vuetify/es5/components/VBtnToggle'
import VCard from 'vuetify/es5/components/VCard'
import VForm from 'vuetify/es5/components/VForm'
import VTextField from 'vuetify/es5/components/VTextField'
import VCheckbox from 'vuetify/es5/components/VCheckbox'
import VSwitch from 'vuetify/es5/components/VSwitch'
import VSelect from 'vuetify/es5/components/VSelect'
import VProgressLinear from 'vuetify/es5/components/VProgressLinear'
import VProgressCircular from 'vuetify/es5/components/VProgressCircular'
import VDataTable from 'vuetify/es5/components/VDataTable'
import VDialog from 'vuetify/es5/components/VDialog'
import VDatePicker from 'vuetify/es5/components/VDatePicker'
import VTimePicker from 'vuetify/es5/components/VTimePicker'
import VSnackbar from 'vuetify/es5/components/VSnackbar'
import VExpansionPanel from 'vuetify/es5/components/VExpansionPanel'
import transitions from 'vuetify/es5/components/transitions'
import directives from 'vuetify/es5/directives'

//// FontAwesome imports
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import fontawesome from '@fortawesome/fontawesome'
import faUser from '@fortawesome/fontawesome-pro-light/faUser'
import faChevronDown from '@fortawesome/fontawesome-pro-light/faChevronDown'
import faCog from '@fortawesome/fontawesome-pro-light/faCog'
import faPencilAlt from '@fortawesome/fontawesome-pro-light/faPencilAlt'
import falFileAlt from '@fortawesome/fontawesome-pro-light/faFileAlt'
import falEdit from '@fortawesome/fontawesome-pro-light/faEdit'
import falFilePdf from '@fortawesome/fontawesome-pro-light/faFilePdf'
import farPlus from '@fortawesome/fontawesome-pro-regular/faPlus'
import falFileAudio from '@fortawesome/fontawesome-pro-light/faFileAudio'
import falFileVideo from '@fortawesome/fontawesome-pro-light/faFileVideo'
import faChevronLeft from '@fortawesome/fontawesome-pro-regular/faChevronLeft'
import farLink from '@fortawesome/fontawesome-pro-regular/faLink'
import falFileImage from '@fortawesome/fontawesome-pro-light/faFileImage'
import falSearch from '@fortawesome/fontawesome-pro-light/faSearch'
import falMinusCircle from '@fortawesome/fontawesome-pro-light/faMinusCircle'
import falPlus from '@fortawesome/fontawesome-pro-light/faPlus'
import falSpinnerThird from '@fortawesome/fontawesome-pro-light/faSpinnerThird'
import falCheckCircle from '@fortawesome/fontawesome-pro-light/faCheckCircle'
import falSort from '@fortawesome/fontawesome-pro-light/faSort'
import falDownload from '@fortawesome/fontawesome-pro-light/faDownload'
import faCircle from '@fortawesome/fontawesome-pro-solid/faCircle'
import fasMinus from '@fortawesome/fontawesome-pro-solid/faMinus'
////

import {VueEditor} from 'vue2-editor'
import * as VueGoogleMaps from 'vue2-google-maps'
// import {GmapMarker} from 'vue2-google-maps/src/components/marker'

// main.styl
import 'vuetify/src/stylus/main.styl' // Ensure you are using stylus-loader
import 'material-design-icons-iconfont/dist/material-design-icons.css'


import TextShortField from './components/fields/TextShortField'
import TextLongField from './components/fields/TextLongField'
import BooleanField from './components/fields/BooleanField'
import NumberField from './components/fields/NumberField'
import DatetimeField from './components/fields/DatetimeField'
import LocationField from './components/fields/LocationField'
import ReferenceField from './components/fields/ReferenceField'
import FileSelectionField from './components/fields/FileSelectionField'
import ReferenceFilter from './components/views/ReferenceFilter'

import EntryTooltip from './components/views/EntryTooltip'

Vue.component('font-awesome-icon', FontAwesomeIcon)
fontawesome.library.add(
    faUser,
    faChevronDown,
    faCog,
    faPencilAlt,
    falFileAlt,
    falEdit,
    falFilePdf,
    farPlus,
    falFileAudio,
    falFileVideo,
    farLink,
    falFileImage,
    falSearch,
    faChevronLeft,
    falMinusCircle,
    falPlus,
    falSpinnerThird,
    falCheckCircle,
    falSort,
    faCircle,
    falDownload,
    fasMinus)

Vue.component('vue-editor', VueEditor)

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDxzT2V8jQH1-sn1wPHJJbQn5BeomTW22c',
        // libraries: 'places', // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)

        //// If you want to set the version, you can do so:
        // v: '3.26',
    },

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then disable the following:
    // installComponents: true,
})
// Vue.component('GmapMarker', GmapMarker)

Vue.use(Vuetify, {
    components: {
        VApp,
        Vuetify,
        VNavigationDrawer,
        VMenu,
        VList,
        VSubheader,
        VDivider,
        VToolbar,
        VContent,
        VTooltip,
        VBtn,
        VBtnToggle,
        VCard,
        VForm,
        VTextField,
        VCheckbox,
        VSwitch,
        VSelect,
        VProgressLinear,
        VProgressCircular,
        VDataTable,
        VDialog,
        VDatePicker,
        VTimePicker,
        VSnackbar,
        VExpansionPanel,
    },
    theme: {
        primary: "#FAFAFA",
        secondary: "#BDBDBD",
        accent: '#546E7A',
        // accent: "#000000",
        error: "#f44336",
        warning: "#e6ae17",
        // warning: "#FFC107",
        info: "#2196f3",
        success: "#33ca6c"
        // success: "#4caf50"
    },
    directives,
    transitions,
})

Vue.component('sfr-text-short-field', TextShortField)
Vue.component('sfr-text-long-field', TextLongField)
Vue.component('sfr-boolean-field', BooleanField)
Vue.component('sfr-number-field', NumberField)
Vue.component('sfr-datetime-field', DatetimeField)
Vue.component('sfr-location-field', LocationField)
Vue.component('sfr-reference-field', ReferenceField)
Vue.component('sfr-file-selection-field', FileSelectionField)
Vue.component('sfr-entry-tooltip', EntryTooltip)
Vue.component('reference-filter', ReferenceFilter)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
